/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DevicesViewerAliases {
  ACTION_ANOTHER_ACTION = 'action-another-action',
  ACTION_EVENT = 'action-event',
  ACTION_REMOVE = 'action-remove',
  ACTION_REPLACE = 'action-replace',
  CONTEXTUAL_BAR_DEVICES_MENU = 'contextual-bar-devices-menu',
  DYNAMIC_FIELDS_DEVICES_VIEWER = 'dynamic-fields-devices-viewer',
  FIELD_ATTEMPT_TIMES = 'field-attemptTimes',
  FIELD_BANDAGE_HOURS_PERMANENCE = 'field-bandage-hours-permanence',
  FIELD_BANDAGE_SCHEDULE_REMOVAL = 'field-bandage-schedule-removal',
  FIELD_CALIBER = 'field-caliber',
  FIELD_DEVICE_COMPLEMENT = 'field-device-complement',
  FIELD_DEVICE_DESCRIPITION = 'field-device-descripition',
  FIELD_DEVICES_USED_QUANTITY = 'field-devices-used-quantity',
  FIELD_END_DATE = 'field-end-date',
  FIELD_INSTALLATION_DATE = 'field-installation-date',
  FIELD_MOTIVO_RETIRADA = 'field-motivo-retirada',
  FIELD_NOTE_DESCRIPTION = 'field-note-description',
  FIELD_PERMANENCIA = 'field-permanencia',
  FIELD_PREVIEW_END_DATE = 'field-preview-end-date',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_SIDE = 'field-side',
  FIELD_TOPOGRAPHY_DESCRIPTION = 'field-topography-description',
  FIELDSET_DEVICES_VIEWER = 'fieldset-devices-viewer',
  FORM_DEVICES_VIEWER = 'form-devices-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_BANDAGE_SCHEDULE_REMOVAL = 'input-bandage-schedule-removal',
  INPUT_DATA_RETIRADA_PREVISTA = 'input-data-retirada-prevista',
  INPUT_END_DATE = 'input-end-date',
  INPUT_INSTALLATION_DATE = 'input-installation-date',
  LAYOUT_DEVICES_VIEWER = 'layout-devices-viewer',
  PANEL_HEADER = 'panel-header',
  TEXT_ATTEMPT_TIMES = 'text-attemptTimes',
  TEXT_CALIBER = 'text-caliber',
  TEXT_DEVICE_COMPLEMENT = 'text-device-complement',
  TEXT_DEVICE_DESCRIPITION = 'text-device-descripition',
  TEXT_DISPOSITIVO_UTIL = 'text-dispositivo-util',
  TEXT_MOTIVO_RETIRADA = 'text-motivo-retirada',
  TEXT_NOTE_DESCRIPTION = 'text-note-description',
  TEXT_PERMANENCIA = 'text-permanencia',
  TEXT_PERMANENCIA_CURATIVO = 'text-permanencia-curativo',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_SIDE = 'text-side',
  TEXT_TOPOGRAPHY_DESCRIPTION = 'text-topography-description',
}
export { DevicesViewerAliases };
